import React from 'react';
import { SignUpLayoutContainerProps } from '../../sign-up-layout-container';
import { SlackPromoConfluenceScreen } from './slack-promo-confluence';
import { UserDataType } from '../../model';

export function ExperimentScreensSwitch(props: SignUpLayoutContainerProps) {
  console.log(`ExperimentScreensSwitch ${props.layout}`);
  if (props.experimentScreensFlags?.enableSlackPromoConfluence) {
    return <SlackPromoConfluenceScreen {...props} />;
  }

  return <SlackPromoConfluenceScreen {...props} />;
}

export function showExperimentScreens(
  props: SignUpLayoutContainerProps,
  userInfo?: UserDataType
) {
  return showSlackPromoConfluenceIneligibleScreen(props, userInfo);
}

function showSlackPromoConfluenceIneligibleScreen(
  props: SignUpLayoutContainerProps,
  userInfo?: UserDataType
) {
  if (!userInfo?.sites) {
    return false;
  }
  const userIsIneligible = userInfo?.sites
    .map((siteData) => {
      return siteData?.edition !== 'free';
    })
    .reduce((userHasAPaidSite: boolean, siteIsPaid: boolean) => {
      return userHasAPaidSite || siteIsPaid;
    }, false);
  return (
    props.experimentScreensFlags?.enableSlackPromoConfluence &&
    userInfo?.isLoggedIn &&
    !!userIsIneligible
  );
}
